import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ba48383c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-manage-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  class: "flex align-center"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "应用", -1));
const _hoisted_5 = {
  style: {
    "width": "250px"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "状态", -1));
const _hoisted_8 = {
  style: {
    "width": "250px"
  }
};
const _hoisted_9 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_10 = {
  style: {
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "space-between"
  }
};
import { findHisApplyManagePage, deleteHisApply, findHisApplyConfigPage, updateHisApplyStatus } from '@/api/upgrade';
import { onMounted, ref } from 'vue';
import Table from './components/table.vue';
import { APP_STATUS_TYPE, appTableDataSchemas } from './config';
import { Search, Refresh } from '@element-plus/icons-vue';
import AddDialog from './components/add';
import usePagination from '@/hooks/usePagination';
import { ElMessageBox, ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const code = ref('');
    const applyStatus = ref('');
    const {
      currentPage,
      total,
      pageSize,
      setPageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const APP_TYPE_OPTIONS = ref([]);
    const appType = ref({});
    const _findHisApplyConfigPage = async () => {
      const res = await findHisApplyConfigPage({
        pageSize: 100
      });
      APP_TYPE_OPTIONS.value = res.records.map(item => {
        appType.value[item.code] = item.name;
        return {
          label: item.name,
          value: item.code
        };
      });
    };

    // 数据相关
    const tableData = ref([]);
    const loading = ref(false);
    // 获取数据的方法
    const getListData = async () => {
      loading.value = true;
      const result = await findHisApplyManagePage({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        code: code.value,
        applyStatus: applyStatus.value
      });
      setTotal(result.total);
      tableData.value = result.records;
      loading.value = false;
    };
    onMounted(() => {
      getListData();
      _findHisApplyConfigPage();
    });
    const handleRefresh = async () => {
      code.value = '';
      applyStatus.value = '';
      setCurrentPage(1);
      await getListData();
    };
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getListData();
    };
    const handleChangeSize = e => {
      setPageSize(e);
      getListData();
    };
    const dialogVisible = ref(false);
    const addUserHandler = () => {
      dialogVisible.value = true;
    };
    const current = ref(null);
    const router = useRouter();
    const handleUpdate = row => {
      // current.value = row
      // dialogVisible.value = true
      router.push(`/operation/upgradeManage/upgradeChange/${row.id}`);
    };
    const currentDup = ref(null);
    const handleDup = row => {
      currentDup.value = row;
      dialogVisible.value = true;
    };
    const handleOpen = async row => {
      ElMessageBox.confirm('确认要上架吗', {
        type: 'warning'
      }).then(async () => {
        // 下架
        await updateHisApplyStatus({
          id: row.id,
          applyStatus: 2
        });
        getListData();
        ElMessage.success('上架成功');
      });
    };
    const handleDown = async row => {
      ElMessageBox.confirm('确认要下架吗', {
        type: 'warning'
      }).then(async () => {
        // 下架
        await updateHisApplyStatus({
          id: row.id,
          applyStatus: 1
        });
        getListData();
        ElMessage.success('下架成功');
      });
    };
    const handleDel = row => {
      ElMessageBox.confirm('确认要删除吗', {
        type: 'warning'
      }).then(async () => {
        try {
          await deleteHisApply(row);
          ElMessage.success('删除成功');
          // 重新渲染数据
          getListData();
        } catch (error) {
          ElMessage({
            message: error,
            type: 'error'
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_select, {
          modelValue: code.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => code.value = $event),
          class: "m-2",
          placeholder: "请选择应用"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(APP_TYPE_OPTIONS.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_select, {
          modelValue: applyStatus.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => applyStatus.value = $event),
          class: "m-2",
          placeholder: "请选择状态"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(APP_STATUS_TYPE), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getListData
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addUserHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['userAdd']]])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createVNode(Table, {
          data: tableData.value,
          currentPage: _unref(currentPage),
          pageSize: _unref(pageSize),
          onUpdate: handleUpdate,
          onDup: handleDup,
          onOpen: handleOpen,
          onDown: handleDown,
          onDel: handleDel,
          loading: loading.value,
          tableSchemas: _unref(appTableDataSchemas)
        }, null, 8, ["data", "currentPage", "pageSize", "loading", "tableSchemas"]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          onSizeChange: handleChangeSize,
          "page-sizes": [12, 24, 36],
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total, sizes, prev, pager, next, jumper",
          style: {
            "margin-bottom": "10px"
          }
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(AddDialog), {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        onRefreshData: getListData,
        APP_TYPE_OPTIONS: APP_TYPE_OPTIONS.value,
        appType: appType.value,
        model: current.value,
        dupModel: currentDup.value,
        onClearModel: _cache[3] || (_cache[3] = () => {
          current.value = null;
          currentDup.value = null;
        })
      }, null, 8, ["modelValue", "APP_TYPE_OPTIONS", "appType", "model", "dupModel"])]);
    };
  }
};